import {MercanciaActionTypes, SAVE_MERCANCIAS} from "../types/mercanciaActionTypes";
import {Mercancia} from "../../entities/solicitudes/Mercancia";

export const initialMercancia: Mercancia = new Mercancia({
    id: 1,
    esEstibable: false,
    camposHabilitados: false,
    embalajeId: 0,
    esFormaValida: true,
    camposRequeridos: [],
    camposInvalidos: [],
});

const initialState: Mercancia[] = [initialMercancia];

export function mercanciaReducer(state = initialState, action: MercanciaActionTypes): Mercancia[] {
    switch (action.type) {
        case SAVE_MERCANCIAS:
            return action.mercancias;
        default:
            return state;
    }
}
